import { Quote } from '../../types/quote'
import { formatRelativeTime } from '../../utils/dateHelpers'
import styles from './QuoteListItem.module.css'

interface QuoteListItemProps {
  quote: Quote
  onEdit: (quote: Quote) => void
  onDelete: (id: string) => void
}

function QuoteListItem({ quote, onEdit, onDelete }: QuoteListItemProps) {
  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <p className={styles.text}>{quote.text}</p>
        {quote.author && (
          <p className={styles.author}>— {quote.author}</p>
        )}
        <p className={styles.meta}>
          Updated {formatRelativeTime(quote.updatedAt)}
        </p>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.editButton}
          onClick={() => onEdit(quote)}
          title="Edit quote"
        >
          ✏️ Edit
        </button>
        <button
          className={styles.deleteButton}
          onClick={() => onDelete(quote.id)}
          title="Delete quote"
        >
          🗑️ Delete
        </button>
      </div>
    </div>
  )
}

export default QuoteListItem
